<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`公司利润表_单车列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #month="params">
        {{ params.params.month ? Number(params.params.month.split('-')[1]) + '月' : "-" }}
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'dwages',
      getListUrl: 'driver',
      breadcrumb: [
        { name: '财务管理', path: '/finance/companyProfit' },
        { name: '公司利润表', path: '/finance/companyProfit' },
        // { name: '车队列表' },
      ],
      formInline: {
        month: undefined,
        license: undefined,
      },
      formCtrl: [
        {
          ...this.ctrls.license,
          label: "车牌号：",
        },
        {
          label: "月份：",
          placeholder: "请选择月份",
          keyName: "month",
          type: 'month',
        },
      ],
      cols: [
        { prop: "month", label: "月份", slot: "month" },
        { prop: 'license', label: '车牌号', minwidth: 120 },
        { prop: 'driver_name', label: '司机', minwidth: 120 },
        { prop: 'allorder', label: '公司运费', minwidth: 120 },
        { prop: 'infreight', label: '司机运费', minwidth: 120 },
        { prop: 'groprofit', label: '公司利润', minwidth: 120 },
        //{ prop: 'ingroprofit', label: '单车平均利润', minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ month, license }) => {
            this.$router.push(
              `/finance/companyProfitOrder?month=${month}&license=${license}`
            );
          },
        },
      ],
      getTotalProperty: ['car_count', 'allorder', 'infreight', 'groprofit', 'avg_profit',],
      baseParams: ['month', 'fleet'],
    };
  },
  methods: {},
  mounted() {
    const { month, fleet } = this.$route.query
    this.MONTH = this.formInline.month = month + ''
    this.formInline.fleet = fleet
    // console.log({ ...this.formInline })
    this.getList()
  },
};
</script>
